export default __webpack_public_path__ + "static/media/migration.693a8735.png";